import Vue from 'vue';
import Component from 'vue-class-component';
import Moment from 'moment';
import { TOOLS_STORE } from '@/tools/store/tools.store';
import { TOOLS_ROUTES } from '@/tools/tools.router';
import { Ref, Watch } from 'vue-property-decorator';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';


@Component({
  name: 'recent-activity'
})
export default class RecentActivityView extends Vue {

  /* Data */
  public loading: boolean = true
  public recentActivitySelected: any = []
  public recentActivityPagination = { current: 1, total: 0 }
  
  @Ref('dataTable') readonly dataTable: any;

  /* Computed */
  get  headers() { 
    return [
      { text: this.$t('tools.recentActivity.ip'), value: 'ip' },
      { text: this.$t('tools.recentActivity.date'), value: 'logDate' },
      { text: this.$t('tools.recentActivity.systemInformation'), value: 'systemInformation' },
      { text: this.$t('tools.recentActivity.browser'), value: 'browser' },
    ]
  }

  get recentActivitiesInfo() {
    return this.$store.state.ToolsStore.recentActivitiesInfo;
  }

  get recentActivities() {
    this.loading = true;
    
     // Check with store if the page was loaded previously    
    const recentActivitiesElement = this.recentActivitiesInfo?.find(el => el.page === this.recentActivityPagination['current']-1);
    let recentActivities = recentActivitiesElement?.content;
    this.recentActivityPagination.total = recentActivitiesElement?.totalPages || 0;
    
    // Fetch new page
    if (!recentActivities) {
      this.$store.dispatch(`${TOOLS_STORE.ACTIONS.GET_RECENT_ACTIVITIES}`, {
        page: this.recentActivityPagination['current']-1, 
        pageSize: 10
      }).then((res) => { 
        this.recentActivityPagination['total'] = res.totalPages;
        this.loading = false;
        return res.content;
      }).catch(() => {
        this.loading = false;
      })
    } else this.loading = false;
    
    return recentActivities;
  } 

  formatLogDate(logDate) {
    return Moment(logDate).format('MMM DD, YYYY hh:mma');
  }

  goBack() {
    this.$router.push({ 
      name: TOOLS_ROUTES.MY_INFO.NAME 
    });
  }

  public onPageUpdate(customEvent: CustomEvent): void {
    const detail: { page: number } = customEvent.detail;
    this.recentActivityPagination['current'] = detail.page;
    this._loadRecentActivityInDataTable();
  }

  @Watch('recentActivities', { immediate: true })
  private _watchRecentActivities(newValue: any, oldValue: any): void {
    this._loadRecentActivityInDataTable();
  }

  private _loadRecentActivityInDataTable(): void {
    if (!this.dataTable || !this.dataTable.loadData) {
      return;
    }

    if (!this.recentActivities || this.recentActivities.length == 0) {
      this.dataTable.loadData({ items: [], headers: this.headers });
      return;
    }

    const slots = {
      'item.logDate': {
        template: '{item.logDate}',
        templateParams: [{
          key: 'item.logDate',
          value: (params) => params.parent.formatLogDate(params.item.logDate),
        }],
      },
      parent: this,
    };

    this.dataTable.loadData({
      items: this.recentActivities,
      headers: this.headers,
      slots: slots,
    });
  }

  private _onLanguageChanged(lang: string): void {
    this.$nextTick(() => {
      this.dataTable?.setAttribute('lang', lang);
      this._loadRecentActivityInDataTable();
    });
  }

  /* Hooks */
  created() {
  
  }
  beforeDestroy() {
    this.$edEventBus.$off(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
  }

  mounted() {
    this.$store.commit(TOOLS_STORE.MUTATIONS.CLEAN_RECENT_ACTIVITIES);
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
    this._loadRecentActivityInDataTable();
  }
}
